export interface User {
    id: number
    email: string
    first_request: Date
    last_request: Date
    requests_count: number
    requests: Request[]
}

export interface UserRequestData {
    ioc: string | {ioc: string}[]
    request_date: Date
}

export class UserRequest {
    data: UserRequestData[]

    constructor(data: any) {
        this.data = data.map((v: any) => {
            let ioc: string | string[]
            try {
                const iocs = JSON.parse(v.ioc)
                ioc = iocs.iocs.filter((v: any) => v.ioc)
            } catch (e) {
                ioc = v.ioc
            }

            return {
                ioc: ioc,
                request_date: v.request_date
            }
        })

    }
}